module.exports = __webpack_public_path__ + "img/MapThumb_LowlandGroves.5057fc59.webp";